<template>
  <div class="flex flex-col justify-between text-center">
    <div :class="`bg-tiers-${selectedSlot.color} text-white py-6 mb-8 relative
    flex justify-end items-center`">
      <div class="w-full text-center font-bold
        tracking-widest uppercase text-lg absolute"
        v-if="selectedSlot.student">
          {{ $t('lesson.lessonWith') }}
          <button class="font-bold" @click="loadDashboard(selectedSlot.student, false)">
            {{ selectedSlot.student.name }}
          </button>
      </div>
      <button @click.prevent="$modal.hide('booked-lesson')" class="px-4 z-20">
        <close-icon />
      </button>
    </div>
    <div class="md:w-3/4 w-5/6 mx-auto flex flex-col justify-between
    font-sans-serif text-lg mb-8 text-center">
      <div class="mb-2">
        <strong>
          {{ selectedEvent && selectedEvent.start.format('DD/MM/YYYY') }}</strong>
      </div>
      <div class="mb-2">
        {{$t('bookingSlots.from')}}  <strong class="mr-4">
          {{ selectedEvent && selectedEvent.start.formatTime() }}</strong>
        {{$t('bookingSlots.to')}} <strong>
          {{ selectedEvent && selectedEvent.end.formatTime() }}</strong>
      </div>
      <div class="py-8">
        <button
          @click="startLesson"
          class="md:px-6 px-5 py-3 rounded border bg-background-academy border-background-academy
          uppercase hover:bg-white text-white hover:text-background-academy
          font-bold cursor-pointer">
            {{ $t('lesson.goClassrooms') }}
        </button>
      </div>
      <div class="flex flex-row justify-between items-center mt-6 text-sm">
        <h2 class="text-black text-center
          tracking-widest uppercase py-2 text-md">
          {{ $t('lesson.needChange') }}
        </h2>
        <modal-button v-if="selectedSlot.student" @click="$emit('change')"
        :buttonPlaceholder="$t('bookingSlots.notify')+selectedSlot.student.firstname"
        buttonClass="uppercase" />
      </div>
    </div>
  </div>
</template>

<script>
import LessonMixin from '@/mixins/LessonMixin';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import ModalButton from '../graphics/ModalButton.vue';
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  props: ['selectedEvent', 'selectedSlot'],

  mixins: [LessonMixin, StreamFunctionsMixin],

  methods: {
    startLesson() {
      this.$router.push('/teacher-dashboard/classrooms');
    },
  },

  components: {
    ModalButton,
    CloseIcon,
  },
};
</script>
